export const REPORT_FILTER_LABELS = Object.freeze({
  BRAND: "Select Brand",
  GROUP: "Select Group",
  STORE: "Select Store",
});

export const REPORT_FILTER_STYLES = {
  control: (styles) => ({
    ...styles,
    borderRadius: "6px",
    minHeight: "2.3rem",
    boxShadow: "none",
    minWidth: "10rem",
  }),
};

export const REPORT_FILTER_OVERLAY_STYLES = {
  ...REPORT_FILTER_STYLES,
  menu: (styles) => ({ ...styles, zIndex: 100 }),
};

export const REPORT_FILTER_CLASSES = Object.freeze({
  SPACED_SELECT: "font-14-px text-secondary w-100 me-2 mb-md-0 mb-2",
  SELECT: "font-14-px text-secondary w-100",
});
